import type { DateRange } from '@zen/DesignSystem/types';

import FilterDatePicker from './components/FilterDatePicker';
import FilterDateRangePicker from './components/FilterDateRangePicker';
import FilterGroup from './components/FilterGroup/FilterGroup';
import FilterMultiSelect from './components/FilterMultiSelect';
import FilterSelect from './components/FilterSelect';
import { registerFilterComponent } from './filterComponentRegistry';
import type { RenderFilterProps } from './types';

const FilterComponent = ({
  props,
  componentType,
  value,
  children,
  active,
  placement = 'bottom-start',
  onChange,
  onDelete,
  deselectFilter,
  disabled
}: RenderFilterProps) => {
  if (componentType === 'select') {
    return (
      <FilterSelect
        active={active}
        deselectFilter={deselectFilter}
        disabled={disabled}
        onChange={onChange}
        onDelete={onDelete}
        placement={placement}
        value={value}
        {...props}
      >
        {(formattedValue) => children(formattedValue)}
      </FilterSelect>
    );
  }

  if (componentType === 'multi-select') {
    return (
      <FilterMultiSelect
        active={active}
        deselectFilter={deselectFilter}
        disabled={disabled}
        onChange={onChange}
        onDelete={onDelete}
        placement={placement}
        value={value as unknown[]}
        {...props}
      >
        {(formattedValue) => children(formattedValue)}
      </FilterMultiSelect>
    );
  }

  if (componentType === 'group') {
    return (
      <FilterGroup
        active={active}
        deselectFilter={deselectFilter}
        disabled={disabled}
        onChange={onChange}
        onDelete={onDelete}
        placement={placement}
        value={value}
        {...props}
      >
        {(formattedValue) => children(formattedValue)}
      </FilterGroup>
    );
  }

  if (componentType === 'date-picker') {
    return (
      <FilterDatePicker
        active={active}
        deselectFilter={deselectFilter}
        disabled={disabled}
        onChange={onChange}
        onDelete={onDelete}
        placement={placement}
        value={value as string}
      >
        {(formattedValue) => children(formattedValue)}
      </FilterDatePicker>
    );
  }

  return (
    <FilterDateRangePicker
      active={active}
      deselectFilter={deselectFilter}
      disabled={disabled}
      onChange={onChange}
      onDelete={onDelete}
      placement={placement}
      value={value as DateRange}
      {...props}
    >
      {(formattedValue) => children(formattedValue)}
    </FilterDateRangePicker>
  );
};

// Register this component so FilterGroup can use it without a circular import
registerFilterComponent(FilterComponent);

export default FilterComponent;
